import { createAction, props } from '@ngrx/store';

import { TemplatePlaceholder } from '@main-application/shared/template-editor-dialog/services/template-editor-dialog.service';
import { RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';
import { RestThresholdSection } from '@shared/interfaces/rest-threshold-section';

import {
  CustomFieldContext,
  CustomFieldModel,
  PropertyBaseCustomFieldsDataModel,
  UpdateCustomFieldAccessModel,
} from '../pages/property-model/services/custom-fields.service';

/**
 * Threshold sections
 */
export const loadAllThresholds = createAction('[Management] Load all thresholds');
export const loadAllThresholdsSuccess = createAction(
  '[Management] All thresholds loading success',
  props<{ thresholdSections: RestThresholdSection[] }>()
);
export const loadAllThresholdsFailed = createAction('[Management] All thresholds loading failed');

/**
 * Thresholds Property
 */
export const loadThresholdsProperty = createAction(
  '[Management] Load thresholds property',
  props<{ portfolioId: number }>()
);
export const loadThresholdsPropertySuccess = createAction(
  '[Management] thresholds property loading success',
  props<{ thresholdProperty: RestThresholdSection[] }>()
);
export const loadThresholdsPropertyFailed = createAction('[Management] thresholds property loading failed');

/**
 * Thresholds task
 */
export const loadThresholdsTask = createAction('[Management] Load thresholds task');
export const loadThresholdsTaskSuccess = createAction(
  '[Management] thresholds task loading success',
  props<{ thresholdTask: RestThresholdSection[] }>()
);
export const loadThresholdsTaskFailed = createAction('[Management] thresholds task loading failed');
export const setThresholdsConfig = createAction(
  '[Management] set thresholds config',
  props<{ threshold: RestThresholdSection }>()
);
export const setThresholdsConfigSuccess = createAction('[Management] set thresholds config success');
export const setThresholdsConfigFailed = createAction('[Management] set thresholds config failed');

/**
 * get renewal target list
 */
export const getRenewalTargetList = createAction(
  '[Management] get renewal target list',
  props<{ propertyId: number }>()
);
export const getRenewalTargetListSuccess = createAction(
  '[Management] get renewal target list success',
  props<{ renewalTargetList: RestUnitRenewalTargetModel[] }>()
);
export const getRenewalTargetListFailure = createAction('[Management] get renewal target list failure');

/**
 * update renewal target
 */
export const updateRenewalTarget = createAction(
  '[Management] update renewal target ',
  props<{ renewalTargetModels: RestUnitRenewalTargetModel[] }>()
);
export const updateRenewalTargetSuccess = createAction('[Management] update renewal target success');
export const updateRenewalTargetFailure = createAction('[Management] update renewal target failure');

/**
 * Custom fields
 */
export const createCustomField = createAction('[Management] Create custom field', props<{ field: CustomFieldModel }>());
export const createCustomFieldSuccess = createAction(
  '[Management] Create custom field success',
  props<{ field: CustomFieldModel }>()
);
export const createCustomFieldFailure = createAction('[Management] Create custom field failure');

export const deleteCustomField = createAction('[Management] Delete custom field', props<{ id: number }>());
export const deleteCustomFieldSuccess = createAction('[Management] Delete custom field success');
export const deleteCustomFieldFailure = createAction('[Management] Delete custom field failure');

export const loadCustomFields = createAction('[Management] Load custom fields');
export const loadCustomFieldsSuccess = createAction(
  '[Management] Load custom fields success',
  props<{ customFields: CustomFieldModel[] }>()
);
export const loadCustomFieldsFailure = createAction('[Management] Load custom fields failure');

export const updateCustomField = createAction('[Management] Update custom field', props<{ field: CustomFieldModel }>());
export const updateCustomFieldSuccess = createAction('[Management] Update custom field success');
export const updateCustomFieldFailure = createAction('[Management] Update custom field failure');

export const loadCustomFieldByContextId = createAction(
  '[Management] Load custom field by context',
  props<{ context: 'portfolio' | 'property' | 'unit'; contextId: number }>()
);
export const loadCustomFieldByContextIdSuccess = createAction(
  '[Management] Load custom field by context success',
  props<{ contextId: number; CustomFieldByContextId: PropertyBaseCustomFieldsDataModel[] }>()
);
export const loadCustomFieldByContextIdFailure = createAction('[Management] Load custom field by context failure');

export const createBaseCustomFieldByContextId = createAction(
  '[Management] Create Base Custom Field By Context Id',
  props<{ context: CustomFieldContext; payload: PropertyBaseCustomFieldsDataModel }>()
);
export const createBaseCustomFieldByContextIdSuccess = createAction(
  '[Management] Create Base Custom Field By Context Id Success',
  props<{ created: PropertyBaseCustomFieldsDataModel }>()
);
export const createBaseCustomFieldByContextIdFailure = createAction(
  '[Management] Create Base Custom Field By Context Id Failure',
  props<{ error: unknown }>()
);

export const updateBaseCustomFieldByContextId = createAction(
  '[Management] Update Base Custom Field By Context Id',
  props<{ context: CustomFieldContext; payload: PropertyBaseCustomFieldsDataModel }>()
);
export const updateBaseCustomFieldByContextIdSuccess = createAction(
  '[Management] Update Base Custom Field By Context Id Success',
  props<{ updated: PropertyBaseCustomFieldsDataModel }>()
);
export const updateBaseCustomFieldByContextIdFailure = createAction(
  '[Management] Update Base Custom Field By Context Id Failure',
  props<{ error: unknown }>()
);

export const deleteBaseCustomFieldByContextId = createAction(
  '[Management] Delete Base Custom Field By Context Id',
  props<{ context: CustomFieldContext; propertyBaseId: number; customFieldId: number }>()
);
export const deleteBaseCustomFieldByContextIdSuccess = createAction(
  '[Management] Delete Base Custom Field By Context Id Success',
  props<{ customFieldId: number }>()
);
export const deleteBaseCustomFieldByContextIdFailure = createAction(
  '[Management] Delete Base Custom Field By Context Id Failure',
  props<{ error: unknown }>()
);

export const changeCustomFieldAccess = createAction(
  '[Management] Change Custom Field Access',
  props<{ payload: UpdateCustomFieldAccessModel }>()
);
export const changeCustomFieldAccessSuccess = createAction('[Management] Change Custom Field Access Success');
export const changeCustomFieldAccessFailure = createAction(
  '[Management] Change Custom Field Access Failure',
  props<{ error: unknown }>()
);

export const loadTemplatePlaceholders = createAction('[Management] Load template placeholders');
export const loadTemplatePlaceholdersSuccess = createAction(
  '[Management] Load template placeholders success',
  props<{ placeholders: TemplatePlaceholder[] }>()
);
export const loadTemplatePlaceholdersFailure = createAction(
  '[Management] Load template placeholders failure',
  props<{ error: unknown }>()
);
